// ** User Roles Enum
export const USER_ROLES = {
  ADMIN: 'admin', // can't edit documents, but can add new admin.
  MANAGER: 'manager', // can edit documents, can't add new admin.
  CUSTOMER: 'customer',
};

// ** Account Types Enum
export const ACCOUNT_TYPES = {
  GUEST: 'guest',
  REGISTER: 'registered',
};

// ** Inputs Types Enum
export const INPUT_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  CURRENCY: 'currency',
  PHONE: 'phone',
  EMAIL: 'email',
  DATE: 'date',
  SSN: 'ssn',
  TEXTAREA: 'textarea',
  RADIO: 'radio',
  GROUP: 'group',
  DYNAMIC_GROUP: 'dynamic_group',
  CHECKBOX: 'checkbox',
  CHECKBOX_MULTIPLE: 'checkbox_multiple',
  FILE_UPLOAD: 'file_upload',
};

export const INPUT_TYPE_LABELS = {
  [INPUT_TYPES.TEXT]: 'Text',
  [INPUT_TYPES.NUMBER]: 'Number',
  [INPUT_TYPES.DROPDOWN]: 'Dropdown',
  [INPUT_TYPES.CURRENCY]: 'Currency',
  [INPUT_TYPES.PHONE]: 'Phone',
  [INPUT_TYPES.EMAIL]: 'Email',
  [INPUT_TYPES.DATE]: 'Date',
  [INPUT_TYPES.SSN]: 'SSN',
  [INPUT_TYPES.TEXTAREA]: 'Textarea',
  [INPUT_TYPES.RADIO]: 'Radio',
  [INPUT_TYPES.GROUP]: 'Group',
  [INPUT_TYPES.DYNAMIC_GROUP]: 'Dynamic Group',
  [INPUT_TYPES.CHECKBOX]: 'Checkbox',
  [INPUT_TYPES.CHECKBOX_MULTIPLE]: 'Checkbox Multiple',
  [INPUT_TYPES.FILE_UPLOAD]: 'File Upload',
};

export const INPUT_VALIDATION = {
  REQUIRED: 'required',
  MIN_LENGTH: 'minLength',
  MAX_LENGTH: 'maxLength',
  MIN_VALUE: 'minValue',
  MAX_VALUE: 'maxValue',
  MIN_DATE: 'minDate',
  MAX_DATE: 'maxDate',
};

// ** Button Themes
export const BUTTON_THEMES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
};

// ** Tax File Type
export const TAX_FILE_TYPE = {
  IN_OFFICE: 'in_office',
  VIRTUAL_INTAKE: 'virtual_intake',
};

// ** Tax File Status
export const TAX_FILE_STATUS = {
  CREATED: 'created',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  SUBMITTED: 'submitted',
  PROCESSED: 'processed',
  ARCHIVED: 'archived',
};

// ** Badge Themes
export const BADGE_THEMES = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
  SECONDARY: 'secondary',
  LIGHT: 'light',
  DARK: 'dark',

  // Status-specific themes
  CREATED: 'CREATED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  SUBMITTED: 'SUBMITTED',
  PROCESSED: 'PROCESSED',
  ARCHIVED: 'ARCHIVED',

  // Section Status themes
  completed: 'completed',
  in_progress: 'in_progress',
  not_started: 'not_started',

  // User Status themes
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
  SUSPENDED: 'SUSPENDED',

  // Quiz Status themes
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  DELETED: 'DELETED',

  // Boolean status
  true: 'true',
  false: 'false',

  // Special badges
  walk_in: 'walk_in',
  exclusive: 'exclusive',
  secure: 'secure',
  conditional: 'conditional',
  opted_out: 'opted_out',
  required: 'required',
  invalid: 'invalid',
  admin_modified: 'admin_modified',
  error: 'error',
};

// ** Badge Sizes
export const BADGE_SIZES = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};

// ** Document Types
export const DOCUMENT_TYPES = {
  W2: 'W2',
  W2G: 'W2G',
  FORM_1099: '1099',
  FORM_1098: '1098',
  ID_PROOF: 'ID_PROOF',
  PASSPORT: 'PASSPORT',
  SOCIAL_SECURITY_CARD: 'SOCIAL_SECURITY_CARD',
  BANK_STATEMENT: 'BANK_STATEMENT',
  TAX_RETURN_PREVIOUS_YEAR: 'TAX_RETURN_PREVIOUS_YEAR',
  RECEIPT: 'RECEIPT',
  INVOICE: 'INVOICE',
  OTHER: 'OTHER',
};

// ** Document Type Labels
export const DOCUMENT_TYPE_LABELS = {
  [DOCUMENT_TYPES.W2]: 'W-2 Form',
  [DOCUMENT_TYPES.W2G]: 'W-2G Form',
  [DOCUMENT_TYPES.FORM_1099]: '1099 Form',
  [DOCUMENT_TYPES.FORM_1098]: '1098 Form',
  [DOCUMENT_TYPES.ID_PROOF]: 'ID Proof',
  [DOCUMENT_TYPES.PASSPORT]: 'Passport',
  [DOCUMENT_TYPES.SOCIAL_SECURITY_CARD]: 'Social Security Card',
  [DOCUMENT_TYPES.BANK_STATEMENT]: 'Bank Statement',
  [DOCUMENT_TYPES.TAX_RETURN_PREVIOUS_YEAR]: 'Previous Year Tax Return',
  [DOCUMENT_TYPES.RECEIPT]: 'Receipt',
  [DOCUMENT_TYPES.INVOICE]: 'Invoice',
  [DOCUMENT_TYPES.OTHER]: 'Other',
};

// ** File Size Limits (in bytes)
export const FILE_SIZE_LIMITS = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_TOTAL_SIZE: 50 * 1024 * 1024, // 50MB total per tax file
};

// ** Allowed File Types
export const ALLOWED_FILE_TYPES = {
  PDF: 'application/pdf',
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  PNG: 'image/png',
};

// ** File Type Labels
export const FILE_TYPE_LABELS = {
  [ALLOWED_FILE_TYPES.PDF]: 'PDF',
  [ALLOWED_FILE_TYPES.JPEG]: 'JPEG',
  [ALLOWED_FILE_TYPES.JPG]: 'JPG',
  [ALLOWED_FILE_TYPES.PNG]: 'PNG',
};

// ** Announcement Urgency Enums
export const ANNOUNCEMENT_URGENCY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
};

// ** Announcement Category Enums
export const ANNOUNCEMENT_CATEGORY = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  MAINTENANCE: 'maintenance',
};

// ** Announcement Target Audience Enums
export const ANNOUNCEMENT_TARGET_AUDIENCE = {
  ALL: 'all',
  CUSTOMER: 'customer',
  MANAGER: 'manager',
  ADMIN: 'admin',
};

// ** Notification Priority Enums
export const NOTIFICATION_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
};

// ** Notification Type Enums
export const NOTIFICATION_TYPE = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  SYSTEM: 'system',
  PROMOTIONAL: 'promotional',
  TRANSACTIONAL: 'transactional',
};

// ** History Events Enum
export const HISTORY_EVENT = {
  IN_OFFICE: {
    CREATED: 'tax_file.created',
    DOCUMENT_UPLOADED: 'tax_file.document_uploaded',
    DOCUMENT_REMOVED: 'tax_file.document_removed',
    DOCUMENT_REPLACED: 'tax_file.document_replaced',
    DOCUMENT_DOWNLOADED: 'tax_file.document_downloaded',
    FILE_VIEWED: 'tax_file.viewed_by_admin',
    STATUS_UPDATED: 'tax_file.status_updated',
    NOTES_ADDED: 'tax_file.notes_added',
    ASSIGNED_TO_MANAGER: 'tax_file.assigned_to_manager',
    CONTENT_COPIED: 'tax_file.content_copied',
  },
  VIRTUAL_INTAKE: {
    CREATED: 'quiz_response.created',
    SECTION_ANSWER_SUBMITTED: 'quiz_response.section_answer_submitted',
    SECTION_ANSWER_UPDATED_BY_ADMIN:
      'quiz_response.section_answer_updated_by_admin',
    SECTION_ANSWER_SAVED_AS_DRAFT:
      'quiz_response.section_answer_saved_as_draft',
    SECTION_ANSWER_SAVED_AS_DRAFT_BY_ADMIN:
      'quiz_response.section_answer_saved_as_draft_by_admin',
    SECTION_DOCUMENT_UPLOADED: 'quiz_response.section_document_uploaded',
    SECTION_DOCUMENT_DELETED: 'quiz_response.section_document_deleted',
    SECTION_DOCUMENT_REPLACED: 'quiz_response.section_document_replaced',
    DOCUMENT_DOWNLOADED: 'quiz_response.document_downloaded',
    FILE_VIEWED: 'quiz_response.file_viewed_by_admin',
    CONTENT_COPIED: 'quiz_response.content_copied_by_admin',
    ANSWER_UPDATED: 'quiz_response.answer_updated',
    NOTES_ADDED: 'tax_file.notes_added',
  },
};

// ** Send SMS via
export const SEND_SMS_VIA = {
  EMAIL: 'email',
  PHONE: 'phone',
};
